export default "__VITE_ASSET__853183c3__"